// extracted by mini-css-extract-plugin
module.exports = {"metricsGrid":"styles_metricsGrid__19JUx"};